var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_c('v-card',[_c('PelatihanComponent',{attrs:{"id":_vm.id,"kegiatanId":_vm.kegiatanId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }